import React from 'react'

interface AccessDeniedProps {
  message?: string
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  message = "You don't have permission to access this page.",
}) => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <h2 className="text-red-800 font-semibold">Access Denied</h2>
          <p className="text-red-600">{message}</p>
        </div>
      </div>
    </div>
  )
}

export default AccessDenied
